import { Link } from '@solidjs/meta';

export function SpaceGrotesk()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300..700&display=swap' rel='stylesheet' />
	</>);
}

SpaceGrotesk.fontFamily = '"Space Grotesk", sans-serif';
